import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
const { Big } = Util;

import cx from "classnames";
// import styles from "./index.module.less";
import stylesProducts from "@/components/Pages/Finance/Styles/products.module.less";
import stylesH5 from "@/components/Pages/Finance/Styles/h5.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
import getProductDefaultSelect from "@/components/Pages/Finance/_hook/getProductDefaultSelect";
import Currency from "@/components/Pages/Finance/_cmpt/Currency";
import XtSvg from "@/components/Xt/Svg";
import Card from "./card";

export default observer(({ data: groupObj, rowCls }) => {
  const t = useTranslation();
  const { finance } = useStore();

  const selfData = useMemo(() => {
    let apyMax = 0;

    groupObj.productCollections.map((categoryObj) => {
      const selectProduct = getProductDefaultSelect(categoryObj.financialProducts);
      let _apyMax = 0;
      selectProduct.apyList &&
        selectProduct.apyList.map((apyObj) => {
          apyObj.annualized > _apyMax && (_apyMax = apyObj.annualized);
        });
      _apyMax > apyMax && (apyMax = _apyMax);
    });

    const convertData = {
      //币种，譬如：usdt
      currency: groupObj.groupTag,
      apy: Big(apyMax).toFixed(2) + "%",
    };

    return convertData;
  }, [groupObj]);

  const [isExpand, setIsExpand] = useState(false);
  const onCollapse = useCallback(() => {
    setIsExpand(!isExpand);
  }, [isExpand]);

  return (
    <div className={cx(stylesH5.list)}>
      <button className={cx("btnTxt", stylesH5.triggerBtn)} onClick={onCollapse}>
        <Currency data={selfData.currency} />
        <div>
          <span className={stylesProducts.apy}>{selfData.apy}</span>
          <XtSvg icon="arr-left" style={{ transform: isExpand ? "rotateZ(90deg)" : "rotateZ(-90deg)" }} />
        </div>
      </button>

      {isExpand && groupObj.productCollections.map((data) => <Card key={data.category} data={data} rowCls={rowCls} />)}
    </div>
  );
});
